import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "checking", data: null });

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState({ status: "error", data: null });
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ status: "paid", data });
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setState({ status: "error", data });
          return;
        }
      } catch {
        /* keep trying */
      }
      if (attempts >= 8) {
        setState({ status: "timeout", data: null });
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="payment-success-page">
      <div className="max-w-lg w-full text-center">
        {state.status === "checking" && (
          <>
            <Loader2 size={56} className="mx-auto animate-spin text-[#D7E85C]" />
            <h1 className="mt-8 font-display font-black text-4xl uppercase tracking-tight text-[#EBE6E0]">
              Confirming your backing…
            </h1>
            <p className="mt-3 text-[#FFFFFF]">Hang tight while we verify your payment with Stripe.</p>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-[#D7E85C]" />
            <h1 className="mt-8 font-display font-black text-5xl uppercase tracking-tight text-[#EBE6E0]" data-testid="payment-success-title">
              You're in.
            </h1>
            <p className="mt-4 text-lg text-[#FFFFFF]">
              Thank you for backing the <span className="text-[#FF8473] font-bold">{state.data?.package_name}</span> tier
              {state.data?.amount ? ` · $${state.data.amount}` : ""}. Welcome to the movement.
            </p>
          </>
        )}
        {(state.status === "error" || state.status === "timeout") && (
          <>
            <XCircle size={56} className="mx-auto text-[#FF8473]" />
            <h1 className="mt-8 font-display font-black text-4xl uppercase tracking-tight text-[#EBE6E0]">
              We couldn't confirm it
            </h1>
            <p className="mt-3 text-[#FFFFFF]">
              Your payment may still be processing. If you were charged, you'll receive an email confirmation.
            </p>
          </>
        )}
        <button
          data-testid="back-home-btn"
          onClick={() => navigate("/")}
          className="mt-10 inline-flex items-center bg-[#EBE6E0] text-[#1F3864] px-7 py-3 rounded-full font-bold uppercase text-sm hover:bg-[#D7E85C] active:scale-95 transition-[background,transform] duration-200"
        >
          Back to Rada Collab
        </button>
      </div>
    </div>
  );
}
